class customDropdown extends HTMLElement {
    constructor() {
      super();
      
      this.triggerBtn = this.querySelector('[data-dropdown-trigger]');
      this.dropdownContentEle = this.querySelector('.dropdown-content');
      this.dropdownContentEles = this.querySelectorAll('.dropdown-content > a');
      this.input = this.querySelector('input[type="hidden"]');
  
      if (this.triggerBtn) {
        this.triggerBtn.addEventListener('click', (e) => {
          e.preventDefault();
          let contentBlockHeight = Utility._getHeightofHiddenEle(this.dropdownContentEle);
          this.classList.toggle('open');
          if (this.classList.contains('open')) {
            this.dropdownContentEle.style.height = contentBlockHeight + 'px';
            setTimeout(() => {
              this.dropdownContentEle.style.height = '';
            }, 200);
          } else {
            this.dropdownContentEle.classList.add('open');
            setTimeout(function () {
              this.dropdownContentEle.style.height = '0';
            }, 1);
            setTimeout(() => {
              this.dropdownContentEle.classList.remove('open');
            }, 200);
          }
        })
      }
  
      if (this.dropdownContentEles.length > 0) {
        this.dropdownContentEles.forEach(opt => {
          opt.addEventListener('click', (e) => {
            e.preventDefault();
            if (e.currentTarget.classList.contains('disabled')) return;
            this.input.value = e.currentTarget.dataset.value;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
            this.triggerBtn.innerHTML = e.currentTarget.innerHTML;
            this.classList.remove('open');
            this.dropdownContentEles.forEach(opt => opt.classList.remove('selected'));
            e.currentTarget.classList.add('selected');
          })
        })
      }
    }
  }
  customElements.define('custom-dropdown', customDropdown);
  
  class ringSizeWidget extends HTMLElement {
    constructor() {
      super();
  
      this.submitBtn = this.querySelector('#findSizeTrigger');
      this.resultEle = document.querySelector('[data-ring-size-result]');
      this.diameterSelectEle = this.querySelector('#inside_diameter');
      this.countrySelectEle = this.querySelector('input[name="country_selector"]');
      this.ringsizeSelectEle = this.querySelector('#ring_size');
      const options = Array.from(this.ringsizeSelectEle.options).map(option => ({
        value: option.value,
        text: option.text,
        size : option.dataset.size,
        country: option.dataset.country
      }));
      localStorage.setItem('ringSizeOptions', JSON.stringify(options));
      this.init();
    }
  
    onSelect = () => {
      this.diameterSelectEle.addEventListener('change', () => {
        this.ringsizeSelectEle.disabled = true;
        this.ringsizeSelectEle.value = '';
      });
      this.ringsizeSelectEle.addEventListener('change', () => {
        this.diameterSelectEle.disabled = true;
        this.diameterSelectEle.value = '';
      });
      this.countrySelectEle.addEventListener('change', (e) => {
        let country = e.currentTarget.value;
        const options = JSON.parse(localStorage.getItem('ringSizeOptions'));

        // Clear existing options
        this.ringsizeSelectEle.innerHTML = '';
        const defaultOptionHTML = `<option value="" selected>select ring size</option>`;
      this.ringsizeSelectEle.insertAdjacentHTML('beforeend', defaultOptionHTML);
        // Filter and append options based on the selected country
        options.forEach(opt => {
          if (opt.value && opt.country.includes(country) && opt.value !== '-') {
            const optionHTML = `
            <option value="${opt.value}" data-country="${opt.country}" data-size="${opt.size}">
              ${opt.text}
            </option>
          `;
          // Append the new option to the select element
          this.ringsizeSelectEle.insertAdjacentHTML('beforeend', optionHTML);

          }
        });
        this.diameterSelectEle.disabled = true;
        this.diameterSelectEle.value = '';
        this.ringsizeSelectEle.value = '';
        this.ringsizeSelectEle.disabled = false;
      });
    }
  
    onSubmit = () => {
      if (!this.submitBtn) return;
  
      this.submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
  
        if (this.diameterSelectEle.value != '') {
          let selectdValue = this.diameterSelectEle.querySelector(`option[value="${this.diameterSelectEle.value}"]`).dataset.size;
          this.resultEle.classList.add('animate');
          this.resultEle.querySelector('span').textContent = selectdValue;
          setTimeout(() => {
            this.resultEle.classList.remove('animate');
          },1000)
  
        } else if (this.ringsizeSelectEle.value != '') {
  
          let selectdValue = this.ringsizeSelectEle.querySelectorAll(`option[value="${this.ringsizeSelectEle.value}"]`);
          selectdValue.forEach(opt => {
            if (opt.dataset.country.includes(this.countrySelectEle.value)) {
              selectdValue = opt.dataset.size
            }
          });
          
          this.resultEle.classList.add('animate');
          this.resultEle.querySelector('span').textContent = selectdValue;
          setTimeout(() => {
            this.resultEle.classList.remove('animate');
          },1000)
        }
  
        this.diameterSelectEle.disabled = false;
        this.ringsizeSelectEle.disabled = false;
      })
  
    }
  
    init = () => {
      this.onSelect();
      this.onSubmit();
    }
  }
  customElements.define('ringsize-widget', ringSizeWidget);